import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const SendIcon = (p: IconProps) => <Icon {...p}><path d="m22 2-7 20-4-9-9-4 20-7z" /><path d="M22 2 11 13" /></Icon>
